module.exports = __webpack_public_path__ + "static/media/capital.6110b4ff.svg";